<template>
    <div class="login">
        <div class="slideWrap" v-if="showIfr">
            <iframe id="iframe1" :src="iframeSrc" frameborder="0"></iframe>
        </div>
        <div class="con">
            <div class="phone">
                <span>+86</span>
                <input type="tel" placeholder="手机号" v-model="phone" />
            </div>
            <div class="key">
                <span class="iconfont">&#xe630;</span>
                <input
                    type="tel"
                    placeholder="验证码"
                    v-model="code"
                    @focus="checkPhoneImg"
                />
                <a
                    v-on:click="getCode"
                    class="getcodeBtn"
                    v-bind:disabled="!(phoneState & timer)"
                    >{{ timerstr }}</a
                >
            </div>
            <div
                class="btnLogin"
                v-bind:disabled="!(phoneState && codeState)"
                v-on:click="login"
            >
                登录
            </div>
            <p>
                登录即代表您同意
                <a href="https://client.qxiu.com/statement/privacy4.html"
                    >齐齐服务和隐私条款</a
                >
            </p>
        </div>
        <div class="cover" v-on:click="outPop"></div>
        <div class="tips" v-if="popTips">
            <p>{{ tips }}</p>
            <a v-on:click="(popTips = false) && (tips = '')">确定</a>
            <i v-on:click="(popTips = false) && (tips = '')">x</i>
        </div>
    </div>
</template>

<script>
import cookie from "../../libs/cookie";
import { mapState } from "vuex";
window.addEventListener("message", function (event) {
    console.log(event.data);
    // _this.getCodeReq(event.data);
});
export default {
    name: "index",
    data() {
        return {
            phone: "", //手机号
            code: "", //验证码
            phoneState: false, //手机校验
            codeState: false, //验证码校验
            tips: "",
            popTips: false,
            timer: true,
            timerstr: "获取验证码",
            iframeSrc: "",
            showIfr: false,
        };
    },
    created() {
        var _this = this;
        window.addEventListener("message", function (event) {
            console.log(event.data);
            _this.getCodeReq(event.data);
        });
    },
    computed: mapState(["channelID", "sourceType", "forceLogin"]),
    methods: {
        outPop() {
            if (this.forceLogin) {
                this.$store.commit("getCurview", "loginmode");
                return;
            }
            this.$store.commit("getCurview", "");
        },
        getCode() {
            var _this = this;
            if (!(_this.phoneState & _this.timer)) {
                return;
            }
            _this.showIfr = true;
            _this.iframeSrc =
                "https://page.qxiu.com/verify/verify_slider.html?isweb=true&mobile=" +
                _this.phone;
        },
        getCodeReq(data) {
            var _this = this;
            _this.showIfr = false;
            $.ajax({
                type: "get",
                url:
                    "https://login-m.qxiu.com/cgi/web/login/phone/sendCode?phone=" +
                    _this.phone +
                    "&verifyType=slider&orderCheckID=" +
                    data,
                async: true,
                dataType: "jsonp",
                success: function (res) {
                    if (res.state == 0 && res.content.sendState == true) {
                        var time = 60;
                        _this.timer = false;
                        var interval = setInterval(function () {
                            _this.timerstr = time;
                            time--;
                            if (time == 0) {
                                clearInterval(interval);
                                _this.timer = true;
                                _this.timerstr = "获取验证码";
                            }
                        }, 1000);
                        window.toast("验证码发送成功");
                    } else {
                        window.toast(res.message);
                    }
                },
            });
        },
        login() {
            if (this.phoneState && this.codeState) {
                var _this = this;
                $.ajax({
                    type: "get",
                    url:
                        "https://login-m.qxiu.com/cgi/web/login/phone?phone=" +
                        _this.phone +
                        "&code=" +
                        _this.code +
                        "&oemid=" +
                        (cookie.get("oemid") || 201) +
                        "" +
                        (_this.sourceType
                            ? "&sourceType=" + _this.sourceType
                            : "") +
                        (_this.channelID
                            ? "&channelid=" + _this.channelID
                            : ""),
                    async: true,
                    dataType: "jsonp",
                    success: function (res) {
                        if (
                            res.state == 0 &&
                            (res.content.openid || res.content.DLopenid)
                        ) {
                            if (cookie.get("isxiaoxiong") == "true") {
                                cookie.set("ip", res.content.DLip, {
                                    domain: "qxiu.com",
                                });
                                cookie.set("isNew", res.content.DLisNew, {
                                    domain: "qxiu.com",
                                });
                                cookie.set("isnp", res.content.DLisnp, {
                                    domain: "qxiu.com",
                                });
                                cookie.set("mcheck", res.content.DLmeck, {
                                    domain: "qxiu.com",
                                });
                                cookie.set("nick", res.content.DLnickname, {
                                    domain: "qxiu.com",
                                });
                                cookie.set("openid", res.content.DLopenid, {
                                    domain: "qxiu.com",
                                });
                                cookie.set(
                                    "accessToken",
                                    res.content.DLaccessToken,
                                    { domain: "qxiu.com" }
                                );
                                cookie.set("uid", res.content.DLuid, {
                                    domain: "qxiu.com",
                                });
                                cookie.set("webToken", res.content.DLwebToken, {
                                    domain: "qxiu.com",
                                });
                                cookie.set("photo", res.content.DLphoto, {
                                    domain: "qxiu.com",
                                });
                                cookie.set(
                                    "szNickMd5",
                                    res.content.DLszNickMd5,
                                    { domain: "qxiu.com" }
                                );
                            } else {
                                cookie.set("ip", res.content.ip, {
                                    domain: "qxiu.com",
                                });
                                cookie.set("isNew", res.content.isnew, {
                                    domain: "qxiu.com",
                                });
                                cookie.set("isnp", res.content.isnp, {
                                    domain: "qxiu.com",
                                });
                                cookie.set("mcheck", res.content.meck, {
                                    domain: "qxiu.com",
                                });
                                cookie.set("nick", res.content.nickname, {
                                    domain: "qxiu.com",
                                });
                                cookie.set("openid", res.content.openid, {
                                    domain: "qxiu.com",
                                });
                                cookie.set("accessToken", res.content.openkey, {
                                    domain: "qxiu.com",
                                });
                                cookie.set("uid", res.content.userid, {
                                    domain: "qxiu.com",
                                });
                                cookie.set("webToken", res.content.webToken, {
                                    domain: "qxiu.com",
                                });
                                cookie.set("photo", res.content.photo, {
                                    domain: "qxiu.com",
                                });
                                cookie.set("szNickMd5", res.content.szNickMd5, {
                                    domain: "qxiu.com",
                                });
                            }
                            _this.$store.commit("getCurview", "");
                            location.reload();
                        } else {
                            window.toast(res.msg);
                        }
                    },
                });
            }
        },
        checkPhone() {
            if (!/^1[234578]\d{9}$/.test(this.phone)) {
                alert("请输入11位正确的手机号");
            }
        },
        checkPhoneImg() {
            if (!/^1[234578]\d{9}$/.test(this.phone)) {
                alert("请输入11位正确的手机号");
            }
        },
    },
    watch: {
        phone() {
            if (/^1[234578]\d{9}$/.test(this.phone)) {
                this.phoneState = true;
            } else {
                this.phoneState = false;
            }
        },
        code() {
            if (/^\d{6}$/.test(this.code)) {
                this.codeState = true;
            } else {
                this.codeState = false;
            }
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 200;
}

.con {
    position: fixed;
    width: 14.2rem;
    bottom: 0;
    left: 50%;
    margin-left: -7.5rem;
    padding: 0.8rem 0.4rem 0.4rem;
    background: #fff;
    z-index: 10;
}

.con > p {
    text-align: center;
    margin-top: 0.5rem;
    color: #ccc;
    font-size: 0.4rem;
}

.con > p a {
    color: #ccc;
    text-decoration: underline;
}

.phone,
.key {
    height: 1.92rem;
    border: 1px solid #ccc;
    border-radius: 0.4rem;
    margin-bottom: 0.6rem;
}

.phone > span,
.key > span {
    position: relative;
    display: inline-block;
    width: 2.64rem;
    text-align: center;
    line-height: 1.92rem;
    font-size: 0.52rem;
    color: #ff4656;
}

.phone > input,
.key > input {
    line-height: 1.2rem;
    width: 7rem;
    vertical-align: top;
    margin-top: 0.36rem;
    padding-left: 0.8rem;
    border: none;
    font-size: 0.52rem;
}

.phone > span:after,
.key > span:after {
    content: "";
    display: inline-block;
    width: 1px;
    height: 1.2rem;
    background: #ccc;
    position: absolute;
    right: 0;
    top: 0.36rem;
}

.key a {
    display: inline-block;
    width: 2.92rem;
    height: 0.96rem;
    border: 0.04rem solid #ff4656;
    border-radius: 0.2rem;
    font-size: 0.48rem;
    color: #ff4656;
    text-align: center;
    line-height: 0.96rem;
}

.btnLogin {
    width: 14.2rem;
    height: 1.8rem;
    background: #ff4656;
    border-radius: 0.2rem;
    text-align: center;
    font-size: 0.64rem;
    line-height: 1.8rem;
    color: #fff;
    margin-top: 1.2rem;
}

.btnLogin[disabled] {
    background: #ccc;
}

.cover {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}

a.chageImg {
    width: 2rem;
    vertical-align: top;
    margin-top: 0.46rem;
}

.getcodeBtn[disabled] {
    color: #ccc;
    border-color: #ccc;
}

.tips {
    width: 11.12rem;
    height: 4.8rem;
    position: absolute;
    top: 50%;
    left: 50%;
    border: 1px solid #d5d5d3;
    margin: -2.9rem 0 0 -5.5rem;
    padding-top: 1.5rem;
    background: #fff;
    border-radius: 0.4rem;
    text-align: center;
    z-index: 10;
}

.tips a {
    display: block;
    width: 6rem;
    height: 1.2rem;
    background: #ee3f81;
    border-radius: 0.24rem;
    margin-top: 1.5rem;
    color: #fff;
    margin: 1.6rem auto 0;
    line-height: 1.2rem;
}

.tips i {
    position: absolute;
    top: 0;
    right: 0.4rem;
    font-size: 1rem;
}
.slideWrap {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 11;
}
iframe {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 10rem;
    height: 7.5rem;
    margin: -3.75rem 0 0 -5rem;
}
</style>



// WEBPACK FOOTER //
// phoneLogin.vue?6e9c1583